<template>
  <a-modal
    title="修改会员分组"
    :width="600"
    :visible="visible"
    @cancel="handleCancel"
    :closable="false"
    :confirmLoading="confirmLoading"
  >
    <a-form :form="form">
      <a-form-item label="选择会员分组" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select v-decorator="['grouptype', {rules: [{required: true, message: '必填项'}]}]">
          <template v-for="(item,index) in groups">
            <a-select-option :key="index" :value="item.id">{{item.name}}</a-select-option>
          </template>
        </a-select>
      </a-form-item>
    </a-form>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleSeccess" :loading="confirmLoading">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import { mapActions } from 'vuex'
import FansApi from '@/api/fans'
export default {
  components: {},
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      visible: false,
      form: this.$form.createForm(this),
      uids: [],
      robotid: null,
      confirmLoading: false,
      groups: []
    }
  },
  created() {
  },
  methods: {
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG']),
    show({ robotid, uids }) {
      this.visible = true
      this.robotid = robotid
      this.uids = uids
      this.getData()
    },
    handleCancel() {
      this.visible = false
    },
    handleSeccess() {
      this.form.validateFields((err, values) => {
        if (!err) {
          const obj = {
            usertype: values.grouptype,
            uid: this.uids,
            sub_id: this.robotid
          }
          this.confirmLoading = true
          FansApi.updateFansGroup(obj).then(res => {
              if (res.code === 1) {
                this.$message.success('操作成功')
                this.visible = false
                this.$emit('ok')
              } else {
                this.$message.error(res.msg)
              }
            }).finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    getData() {
      FansApi.getGroupList({ sub_id: this.robotid }).then(res => {
        this.groups = res.data
      })
    }
  }
}
</script>
<style lang="less">
</style>
